export const productSubcategory = {
  ['Grabaut_Zero_MB']: 'zero',
  ['Grabaut_Strike2_MB']: 'zero',
  ['Grabaut_2NOW_MB']: '2now',
  ['Grabaut_P_MB']: 'premier',
  ['Grabaut_AIR_MB']: 'air',
  ['Grabaut_VIVA_MB']: 'viva',
  ['Grabaut_VIVA_PLUS_MB']: 'viva plus',
};
